import { render, staticRenderFns } from "./WpTopRight.vue?vue&type=template&id=32e7bd88&"
import script from "./WpTopRight.vue?vue&type=script&lang=js&"
export * from "./WpTopRight.vue?vue&type=script&lang=js&"
import style0 from "./WpTopRight.vue?vue&type=style&index=0&id=32e7bd88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports